import React from 'react';
import { IconButton } from '@mui/material';
import { Close as IconClose, CheckCircleOutlined as CheckCircleOutlinedIcon, HighlightOffOutlined as HighlightOffOutlinedIcon, InfoOutlined as InfoOutlinedIcon, ReportProblemOutlined as ReportProblemOutlinedIcon, } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { SnackbarProvider as NotistackProvider, useSnackbar } from 'notistack';
const Snackbar = styled(NotistackProvider)(({ theme }) => ({
    '&.SnackbarContent-root': {
        borderWidth: '0px',
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.paper,
        '.MuiSvgIcon-root': {
            marginRight: '4px !important',
        },
    },
}));
const SnackbarContext = React.createContext({});
function SnackbarCloseButton({ snackbarKey }) {
    const { closeSnackbar } = useSnackbar();
    return (React.createElement(IconButton, { "aria-label": "snackbar-close", onClick: () => closeSnackbar(snackbarKey) },
        React.createElement(IconClose, { fontSize: "small" })));
}
function SnackbarProvider({ children }) {
    return (React.createElement(Snackbar, { maxSnack: 3, dense: true, iconVariant: {
            success: React.createElement(CheckCircleOutlinedIcon, { fontSize: "large", color: "success" }),
            error: React.createElement(HighlightOffOutlinedIcon, { fontSize: "large", color: "error" }),
            info: React.createElement(InfoOutlinedIcon, { fontSize: "large", color: "info" }),
            warning: React.createElement(ReportProblemOutlinedIcon, { fontSize: "large", color: "warning" }),
            default: React.createElement(InfoOutlinedIcon, { fontSize: "large", color: "action" }),
        }, preventDuplicate: true, autoHideDuration: 10000, anchorOrigin: { horizontal: 'right', vertical: 'bottom' }, action: (snackbarKey) => React.createElement(SnackbarCloseButton, { snackbarKey: snackbarKey }) }, children));
}
export { SnackbarContext, SnackbarProvider };
